const config = {
	baseURL:'https://new.guojiyun168.com/api/',
	// baseURL:'http://localhost:4100/'
}

export default config
